var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93909 4.49943L7.80299 1.64179C8.06415 1.38059 8.06415 0.957099 7.80299 0.6959C7.54183 0.4347 7.1184 0.4347 6.85724 0.6959L4 3.56021L1.14276 0.6959C0.881599 0.4347 0.458171 0.4347 0.197008 0.6959C-0.0641539 0.957099 -0.0641539 1.38059 0.197008 1.64179L3.06091 4.49943L0.197008 7.35708C0.0709219 7.48215 0 7.65241 0 7.83002C0 8.00763 0.0709219 8.17789 0.197008 8.30296C0.322065 8.42907 0.492298 8.5 0.669885 8.5C0.847472 8.5 1.0177 8.42907 1.14276 8.30296L4 5.43866L6.85724 8.30296C6.9823 8.42907 7.15253 8.5 7.33011 8.5C7.5077 8.5 7.67793 8.42907 7.80299 8.30296C7.92908 8.17789 8 8.00763 8 7.83002C8 7.65241 7.92908 7.48215 7.80299 7.35708L4.93909 4.49943Z",
    fill: "#212B36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.4ba6d051aec1582c42a874e2e1724294.svg";
export { ForwardRef as ReactComponent };